module.exports = __webpack_public_path__ + "static/media/good_food_only.2a9f738f.webp";